import { FileCheck2 } from "lucide-react";
import { ManualeLayout, Scheda, P, Steps, Bullets, Callout, FAQ } from "@/pages/manuali/ManualeLayout";

const A = "#0d9488";
const SEZIONI = [
  { id: "intro", titolo: "A cosa serve" },
  { id: "catalogo", titolo: "Catalogo (prerequisiti)" },
  { id: "wizard", titolo: "Creare un fascicolo (wizard)" },
  { id: "pratiche", titolo: "Pratiche e stati" },
  { id: "faq", titolo: "FAQ" },
];

export default function ManualeMup() {
  return (
    <ManualeLayout titolo="MUP Assietica" sottotitolo="Modulo Unico Precontrattuale — fascicolo informativo IVASS" icona={FileCheck2} accent={A} sezioni={SEZIONI}>
      <Scheda id="intro" n="1" titolo="A cosa serve" accent={A}>
        <P>Genera il <b>fascicolo precontrattuale</b> da consegnare al cliente prima della sottoscrizione, con i modelli informativi IVASS (Allegati) e i dati di intermediario, compagnia e prodotto.</P>
      </Scheda>

      <Scheda id="catalogo" n="2" titolo="Catalogo (prerequisiti)" accent={A}>
        <P>Prima di creare i fascicoli, popola il <b>Catalogo</b> (tab dedicate):</P>
        <Bullets items={[
          "Prodotti — i prodotti assicurativi trattati.",
          "Compagnie — le compagnie mandanti.",
          "Intermediari — gli intermediari attivi (con dati RUI).",
          "Template (Compliance) — i testi regolamentari (es. Allegato 3) da riutilizzare.",
        ]} />
        <Callout tipo="info">Un catalogo aggiornato rende la compilazione del wizard più rapida e coerente.</Callout>
      </Scheda>

      <Scheda id="wizard" n="3" titolo="Creare un fascicolo (wizard)" accent={A}>
        <P>“Nuova pratica” avvia un <b>percorso guidato a step</b>:</P>
        <Steps items={[
          "Cliente: tipo (persona/azienda), nome/ragione sociale, CF/P.IVA, contatti.",
          "Intermediario: selezione dell'intermediario attivo.",
          "Compagnia e Prodotto: scelta compagnia, prodotto e n. proposta/polizza.",
          "Testi/Allegato 3: incolla o richiama il testo regolamentare approvato.",
          "Dati compilazione: data, canale di distribuzione, modalità di consegna e firma, note (intermediario, cliente, interne).",
          "Riepilogo: verifica e genera il fascicolo.",
        ]} />
        <Callout tipo="warn">Le “Note interne” NON compaiono nel fascicolo consegnato al cliente; le note intermediario/cliente sì.</Callout>
      </Scheda>

      <Scheda id="pratiche" n="4" titolo="Pratiche e stati" accent={A}>
        <P>La sezione <b>Pratiche</b> elenca i fascicoli con filtro per stato e ricerca. Da qui apri il dettaglio, riprendi una bozza o scarichi il fascicolo generato.</P>
      </Scheda>

      <Scheda id="faq" n="5" titolo="FAQ" accent={A}>
        <FAQ items={[
          { q: "Non trovo l'intermediario nel wizard.", a: "Aggiungilo prima nel Catalogo → Intermediari e impostalo come attivo." },
          { q: "Posso salvare a metà?", a: "Sì: la pratica resta come bozza e la riprendi dalla sezione Pratiche." },
          { q: "Dove imposto il testo dell'Allegato 3?", a: "Nel Catalogo → Template (Compliance) crei i testi riutilizzabili, poi li richiami nello step dedicato." },
        ]} />
      </Scheda>
    </ManualeLayout>
  );
}
